import React from 'react';
import { connect } from "react-redux";
import {Grid} from "semantic-ui-react";
import VeritasHeader from "../../shared/VeritasHeader";
import {fetchAllBillingGroups} from "../actions/BillingGroupActions";
import BillingGroupsTable from "./BillingGroupsTable";
import {InlineLoading} from "../../../common/partials/Loading";
import Breadcrumb from '../../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../breadcrumb/BreadcrumbActions';
import Sidebar from "../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../shared/VeritasSidebarButtons";

export class BillingGroupsListPage extends React.Component {

    componentDidMount() {
        document.title = `Veritas - Billing Groups`;
        // If the application reloads at this point, make an API call
        // to get all the providers so that for a possible navigation
        // directly to the Data Providers List page, the data is
        // loaded for rendering. This will also help in refreshing the list
        // if any edits are performed on the detail page.
        this.props.getAllBillingGroups();
        this.props.setBreadCrumb({
            parent:  { url: '/veritas', text: 'Veritas' },
            list:    { url: '/veritas/billing-groups', text: 'Billing Groups' },
            service: { url: '', text: ''},
            source:  { url: '', text: ''},
        })
    }

    render() {
        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.filtered_all_billing_groups
                            ? (<BillingGroupsTable BillingGroups={this.props.filtered_all_billing_groups}/>)
                            : (<InlineLoading/>)
                        }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_billing_groups: state.veritas.billingGroups.all_billing_groups,
    filtered_all_billing_groups: state.veritas.billingGroups.filtered_all_billing_groups,
});

const mapDispatchToProps = dispatch => ({
    getAllBillingGroups: () => {dispatch(fetchAllBillingGroups())},
    setBreadCrumb: (crumb) => {dispatch(setBreadCrumb(crumb))},
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingGroupsListPage)
